import React from 'react';

import Link from '@material-ui/core/Link';

export default function TermsOfUse(props)
{
  return (
    <Link color="inherit" {...props} href="https://www.uts-navi.com/privacy.html">
      プライバシーポリシー
    </Link>
  );
}